import React from 'react';
import { Provider } from 'react-redux';
import ConfigStore from './store/ConfigStore';
const store = ConfigStore();
import Product from './views/Product';
import { hot } from 'react-hot-loader';

const Root = () => (
  <Provider store={store}>
    <Product />
  </Provider>
);

export default hot(module)(Root);



// WEBPACK FOOTER //
// ./src/product/root.js